module.exports = __webpack_public_path__ + "img/pago-efectivo.099af594.svg";